export interface NewFeatureBadgeProps {
  colorType: NewFeatureBadgeColorType;
  className?: string;
}

export enum NewFeatureBadgeColorType {
  PREMIUM = 'premium',
  SECONDARY = 'secondary',
}